module.exports = __webpack_public_path__ + "advantages-mobile.jpg";